import { useRecentItems } from '@/lib/use-recent-items';
import { Link, useLocation } from 'react-router';

interface SidebarRecentItemsProps {
  title: string;
  storageKey: string;
  basePath: string;
}

export function SidebarRecentItems({ title, storageKey, basePath }: SidebarRecentItemsProps) {
  const items = useRecentItems(storageKey);
  const { pathname } = useLocation();

  if (items.length === 0) return null;

  return (
    <div>
      <p className="text-text-3 text-3xs mb-1 px-2.5 font-mono font-medium tracking-[.12em] uppercase">{title}</p>
      <ul className="space-y-0.5">
        {items.map((item) => {
          const to = `${basePath}/${item.id}`;
          const isActive = pathname === to;

          return (
            <li key={item.id}>
              <Link
                to={to}
                className={[
                  'text-xxs block truncate border-l-2 px-2.5 py-1.5 font-mono transition-colors',
                  isActive
                    ? 'border-l-primary-9 bg-surface-2 text-text-1'
                    : 'text-text-3 hover:bg-surface-2/50 hover:text-text-2 border-l-transparent',
                ].join(' ')}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
